// extracted by mini-css-extract-plugin
export default {"content":"visually-hidden-content-fqVa2Z"};